var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "messageList", staticClass: "viq-msg-list" },
    [
      _vm.messagesLoading
        ? _c(
            "div",
            { staticClass: "viq-msg-list__loading" },
            [_c("ViqMessageLoading")],
            1
          )
        : [
            _vm._l(_vm.sortedMessages, function (msg, i) {
              return [
                msg.role === "user"
                  ? _c("ViqMessageUser", {
                      key: msg.id || i,
                      attrs: { message: msg },
                    })
                  : msg.role === "assistant"
                  ? _c("ViqMessageAssistant", {
                      key: msg.id || "a" + i,
                      attrs: {
                        message: msg,
                        "is-last": i === _vm.sortedMessages.length - 1,
                        "is-streaming":
                          _vm.isStreaming &&
                          i === _vm.sortedMessages.length - 1,
                      },
                    })
                  : _vm._e(),
              ]
            }),
            _vm._v(" "),
            _vm.isStreaming && _vm.sortedMessages.length === 0
              ? _c("ViqMessageLoading")
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }